import script from "./ExtensionManage.vue?vue&type=script&setup=true&lang=js"
export * from "./ExtensionManage.vue?vue&type=script&setup=true&lang=js"

import "./ExtensionManage.vue?vue&type=style&index=0&id=2c6cc306&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c6cc306"]])

export default __exports__